import * as S from '../Button/Button.styles';
import Tooltip from '../ReactTooltip/Tooltip';
import { v4 as uuid } from 'uuid';
import theme from 'theme';
import { useMemo } from 'react';

interface IEditButtonProps {
    onClick: () => void;
}

const EditButton = ({ onClick }: IEditButtonProps) => {
    const tooltipId = useMemo(() => uuid(), []);
    return (
        <Tooltip text="Edit" tooltipId={tooltipId}>
            <S.IconWrapper onClick={onClick} data-tip data-for={tooltipId}>
                <S.EditIcon 
                    fill={theme.sherpaBlue}
                />
            </S.IconWrapper>
        </Tooltip>
    );
};

export default EditButton;
